module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/05f303cf5e0d682448fd86af2b820d27.png";